// ============================================================
//  SVG ICON IMPORTS
//  Place your .svg files in: src/assets/
//  File names must match the imports below (or rename to suit).
// ============================================================

// Wealth service icons
import pmsIcon from '../assets/pms.svg';
import smallcaseIcon from '../assets/smallcase.svg';
import aifIcon from '../assets/aif.svg';
import mutualFundsIcon from '../assets/mutual-fund.svg';
import stockMarketIcon from '../assets/stock-market.svg';
import etfIcon from '../assets/etf.svg';
import ipoIcon from '../assets/ipo.svg';
import fixedDepositIcon from '../assets/fd.svg';
import currencyCommodityIcon from '../assets/currency-commodity.svg';
import bondNpsIcon from '../assets/bond.svg';

// Finance service icons
import housingLoanIcon from '../assets/housing-loan.svg';
import mortgageLoanIcon from '../assets/mortgage-loans.svg';
import smeLoanIcon from '../assets/sme-business-loans.svg';
import personalLoanIcon from '../assets/personal-loans.svg';

// Risk service icons
import lifeInsuranceIcon from '../assets/life-insurance.svg';
import healthInsuranceIcon from '../assets/health-insurance.svg';
import generalInsuranceIcon from '../assets/general-insurance.svg';

export const SITE = {
  name: 'LMS Marketing & Services',
  shortName: 'LMS M&S',
  tagline: 'The Art of Growing Wealth',
  taglineSub: 'Believe in the Best Service & Satisfaction',
  advisorySince: '2000',
  consultant: {
    name: 'G.M. Narendra',
    credentials: ['M.Com', 'MBA', 'PGDCS'],
    title: 'Management Consultant & Founder',
  },
  contact: {
    phone: '9849131273',
    email: 'wealth@lmsfinserv.com',
    address: 'Plot-50, Flat No.2, Manohar Enclave, Krishnapuri Colony, Marredpally, Secunderabad (T.S.) – 500026',
    city: 'Secunderabad, Hyderabad',
    state: 'Telangana, India',
  },
  stats: [
    { num: '25+', label: 'Years Experience' },
    { num: '1000+', label: 'Happy Clients' },
    { num: '₹100Cr+', label: 'Assets Managed' },
    { num: '50+', label: 'Instruments' },
  ],
};

export const WEALTH_SERVICES = [
  {
    id: 'pms',
    icon: pmsIcon,
    name: 'Portfolio Management Services',
    short: 'PMS',
    tagline: 'Professionally managed equity portfolios',
    desc: 'Customized, research-backed equity portfolios managed by seasoned professionals for high-net-worth individuals seeking superior long-term wealth creation.',
    features: ['Personalized investment strategy', 'Active portfolio monitoring', 'Quarterly performance reports', 'Direct equity ownership', 'SEBI registered advisory'],
    minInvestment: '₹50 Lakhs',
    riskLevel: 'High',
  },
  {
    id: 'smallcase',
    icon: smallcaseIcon,
    name: 'Smallcase',
    short: 'Smallcase',
    tagline: 'Curated thematic stock baskets',
    desc: 'Invest in ready-made baskets of stocks and ETFs built around a theme, sector, or investment strategy — managed by leading research analysts.',
    features: ['Theme-based investing', 'Low minimum investment', 'Transparent portfolio', 'One-click rebalancing', 'Expert-curated baskets'],
    minInvestment: '₹2 Lakhs',
    riskLevel: 'Medium-High',
  },
  {
    id: 'aif',
    icon: aifIcon,
    name: 'Alternative Investment Fund',
    short: 'AIF',
    tagline: 'Exclusive alternative investment access',
    desc: 'Access exclusive private equity, hedge funds, real estate debt, and other alternative instruments reserved for sophisticated investors seeking uncorrelated returns.',
    features: ['Category I, II & III AIF', 'Private equity access', 'Hedge fund strategies', 'Real estate debt funds', 'Diversified alternatives'],
    minInvestment: '₹1 Crore',
    riskLevel: 'Very High',
  },
  {
    id: 'mutual-funds',
    icon: mutualFundsIcon,
    name: 'Mutual Funds',
    short: 'Mutual Funds',
    tagline: 'Diversified fund selection with SIP',
    desc: 'A wide selection of equity, debt, hybrid and sectoral mutual funds with SIP flexibility — ideal for every investor from beginners to experts.',
    features: ['SIP from ₹500/month', 'Equity, Debt & Hybrid', 'Tax-saving ELSS funds', 'Regular portfolio review', 'Goal-based fund selection'],
    minInvestment: '₹500 SIP',
    riskLevel: 'Low to High',
  },
  {
    id: 'stock-market',
    icon: stockMarketIcon,
    name: 'Stock Market',
    short: 'Stock Market',
    tagline: 'Research-backed equity investing',
    desc: 'Direct equity investing in NSE & BSE with research-backed buy/sell recommendations, technical analysis, and continuous portfolio monitoring.',
    features: ['NSE & BSE trading', 'Fundamental analysis', 'Technical charting', 'Real-time alerts', 'Sector rotation strategy'],
    minInvestment: '₹10,000',
    riskLevel: 'High',
  },
  {
    id: 'etf',
    icon: etfIcon,
    name: 'Exchange Traded Fund',
    short: 'ETF',
    tagline: 'Low-cost passive wealth growth',
    desc: 'Exchange-Traded Funds tracking market indices, sectors, and commodities — offering diversification, transparency, and low expense ratios for cost-conscious investors.',
    features: ['Index & sector ETFs', 'Gold & commodity ETFs', 'Intraday liquidity', 'Low expense ratio', 'Transparent holdings'],
    minInvestment: '₹1,000',
    riskLevel: 'Low-Medium',
  },
  {
    id: 'ipo',
    icon: ipoIcon,
    name: 'Initial Public Offering',
    short: 'IPO',
    tagline: 'Early access to new market listings',
    desc: 'Guided IPO application, allotment strategy, and post-listing monitoring — capture value from primary market opportunities before they hit the secondary market.',
    features: ['IPO research & analysis', 'Application assistance', 'GMP tracking', 'Listing day strategy', 'SME IPO access'],
    minInvestment: '₹14,000 (1 lot)',
    riskLevel: 'Medium-High',
  },
  {
    id: 'fixed-deposit',
    icon: fixedDepositIcon,
    name: 'Fixed Deposit & Debenture',
    short: 'FD & Debenture',
    tagline: 'Guaranteed returns with capital safety',
    desc: 'Stable, predictable fixed deposit and corporate debenture instruments for conservative investors seeking capital protection with attractive yield.',
    features: ['Bank & corporate FDs', 'Corporate debentures', 'Guaranteed returns', 'Flexible tenures', 'Senior citizen benefits'],
    minInvestment: '₹10,000',
    riskLevel: 'Low',
  },
  {
    id: 'currency-commodity',
    icon: currencyCommodityIcon,
    name: 'Currency & Commodity',
    short: 'Currency & Commodity',
    tagline: 'Trade and hedge global markets',
    desc: 'Participate in forex, gold, silver, crude oil, and agricultural commodity markets with expert guidance for trading and portfolio hedging purposes.',
    features: ['Forex trading (USD, EUR, GBP)', 'Gold & Silver', 'Crude oil futures', 'Agricultural commodities', 'Hedging strategies'],
    minInvestment: '₹25,000',
    riskLevel: 'Very High',
  },
  {
    id: 'bond-nps',
    icon: bondNpsIcon,
    name: 'Bond & NPS',
    short: 'Bond & NPS',
    tagline: 'Secure your financial future',
    desc: 'Government and corporate bonds for stable income, combined with the National Pension Scheme for long-term retirement planning with tax benefits.',
    features: ['Govt & corporate bonds', 'Tax-free bonds', 'NPS Tier I & II', 'Retirement planning', 'Section 80C benefits'],
    minInvestment: '₹1,000 (NPS)',
    riskLevel: 'Low-Medium',
  },
];

export const FINANCE_SERVICES = [
  {
    id: 'housing-loan',
    icon: housingLoanIcon,
    name: 'Housing Loan',
    tagline: 'Home loans & mortgage solutions',
    desc: 'Home loans and mortgage solutions with competitive interest rates, fast processing, and expert guidance from application to disbursal.',
    features: ['Home purchase loans', 'Home construction loans', 'Balance transfer', 'Competitive rates', 'Fast disbursal'],
  },
  {
    id: 'mortgage-loan',
    icon: mortgageLoanIcon,
    name: 'Mortgage Loan',
    tagline: 'Loan against property',
    desc: 'Unlock the value of your property with competitive mortgage loans for personal or business needs, with minimal processing time.',
    features: ['Loan against property', 'Residential & commercial', 'Flexible tenure up to 20 yrs', 'Competitive LTV ratio', 'Quick sanctions'],
  },
  {
    id: 'sme-loan',
    icon: smeLoanIcon,
    name: 'SME & Business Loan',
    tagline: 'Fuel your business growth',
    desc: 'Working capital, equipment financing, and business expansion loans tailored for SMEs and entrepreneurs in Telangana.',
    features: ['Working capital loans', 'Equipment financing', 'Business expansion', 'MSME schemes', 'Collateral-free options'],
  },
  {
    id: 'personal-loan',
    icon: personalLoanIcon,
    name: 'Car & Personal Loan',
    tagline: 'Quick approvals, flexible terms',
    desc: 'Quick personal loans and car financing with minimal documentation, competitive rates, and flexible repayment options.',
    features: ['Personal loans up to ₹25L', 'New & used car loans', 'Minimal documentation', 'Flexible tenure', 'Quick approval'],
  },
];

export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Wealth Management', path: '/wealth-management' },
  { label: 'Risk Management', path: '/risk-management' },
  { label: 'Finance', path: '/finance-management' },
  { label: 'Blog', path: '/blogs' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

export const TESTIMONIALS = [
  {
    name: 'Seema Devnani',
    // role: 'Business Owner, Hyderabad',
    text: 'Mr. G. M. Narendra has been managing my investment portfolio since 2017. Over the years, my portfolio has shown good growth, and I am very happy with the results. I am highly satisfied with his services, guidance, and commitment towards wealth creation.',
    rating: 5,
  },
  {
    name: 'Jagirdar Family',
    // role: 'IT Professional, Secunderabad',
    text: 'Mr. G. M. Narendra has been managing our family portfolio with dedication and professionalism. He gives valuable suggestions, and we are very much satisfied with his services. Our entire family appreciates his guidance and support.',
    rating: 5,
  },
  {
    name: 'Amit Kumar Sharma',
    // role: 'Retired Government Officer',
    text: 'Mr. G. M. Narendra has been managing my investment portfolio with dedication and professionalism. I trust his advice and follow his recommendations with confidence. My portfolio has been growing in line with my expectations, and I appreciate his focus on long-term financial planning. His guidance has helped me stay disciplined and committed to my investment goals.',
    rating: 5,
  },
  {
    name: 'Narayandas',
    // role: 'Doctor, Marredpally',
    text: 'Mr. G. M. Narendra has been managing my investment portfolio and has provided excellent guidance for creating wealth for future generations. His suggestions are thoughtful, practical, and focused on long-term financial security. Because of his planning and advice, I feel relaxed and confident knowing that my money is growing for the benefit of my next generation. I am very much satisfied with his services and guidance.',
    rating: 5,
  },
];

export const FAQS = [
  {
    q: 'What is the minimum investment for Mutual Funds?',
    a: 'You can start a SIP in mutual funds with as little as ₹500 per month. Lump sum investments typically start from ₹2 Lakhs depending on the fund.',
  },
  {
    q: 'Is PMS suitable for me?',
    a: 'PMS is designed for high-net-worth investors with a minimum investment of ₹50 Lakhs. It is ideal if you seek personalized, actively managed equity portfolios with potential for higher returns.',
  },
  {
    q: 'How do I open an account with LMS?',
    a: 'Simply call or WhatsApp us at 9849131273 or fill out our contact form. Our team will schedule a free consultation and guide you through the onboarding process.',
  },
  {
    q: 'Are my investments safe with LMS?',
    a: 'LMS acts as your registered financial advisor. All investments are held directly in your name / Demat account. We are SEBI-compliant and follow all regulatory guidelines.',
  },
  {
    q: 'What documents are required to start investing?',
    a: 'Typically, you need PAN card, Aadhaar card, a bank account, and a passport-sized photograph. For specific instruments, additional KYC documents may be required.',
  },
  {
    q: 'Do you offer tax planning advice?',
    a: 'Yes! We help you optimize tax outgo through ELSS mutual funds, NPS (Section 80CCD), insurance premiums (Section 80D), and tax-free bonds as part of holistic financial planning.',
  },
];

export const RISK_SERVICES = [
  {
    id: 'life-insurance',
    icon: lifeInsuranceIcon,
    name: 'Life Insurance',
    short: 'Life Insurance',
    tagline: 'Protect your family\'s financial future',
    desc: 'Term life, whole life, and ULIP plans to protect your family\'s financial future with the right coverage at the right premium.',
    features: ['Term life plans', 'Whole life coverage', 'ULIP investment-insurance', 'Critical illness rider', 'Free comparison across insurers'],
    riskLevel: 'Low',
  },
  {
    id: 'health-insurance',
    icon: healthInsuranceIcon,
    name: 'Health Insurance',
    short: 'Health Insurance',
    tagline: 'Cashless hospitalization & medical cover',
    desc: 'Individual and family floater health plans with cashless hospitalization, covering medical emergencies without draining your savings.',
    features: ['Individual & family floater', 'Cashless hospitalization', 'Pre & post hospitalization', 'No-claim bonus', 'Senior citizen plans'],
    riskLevel: 'Low',
  },
  {
    id: 'general-insurance',
    icon: generalInsuranceIcon,
    name: 'General Insurance',
    short: 'General Insurance',
    tagline: 'Motor, home, travel & commercial cover',
    desc: 'Motor, home, travel, and commercial insurance to protect your assets and liabilities from unexpected events.',
    features: ['Motor insurance', 'Home insurance', 'Travel insurance', 'Commercial property', 'Liability coverage'],
    riskLevel: 'Low',
  },
];